import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import NotFound from "@/pages/NotFound";
import Analytics from "@/components/Analytics";

function App() {
    return (
        <div className="App">
            <Analytics />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "#2D2A26",
                        color: "#F5EFE6",
                        border: "1px solid #3D3A36",
                        borderRadius: "0",
                        fontFamily: "Manrope, sans-serif",
                    },
                }}
            />
        </div>
    );
}

export default App;
